import { GetStatusResponse } from "./basicInformation.model";

export class SendOtpRequest {
  mobileNumber: string | undefined;
}
export class SendOtpResponse {
  key: string | undefined;
  suppliers?: GetStatusResponse | undefined;
  otpLifetime: number | undefined;
  otpLength: number | undefined;
}
export class CheckOtpRequest {
  key: string | undefined;
  otp: string | undefined;
  otpLength: number | undefined;
}
export interface CheckOtpResponse {
  jwt: string;
  refreshToken: string;
}

export interface TokenClaimModel {
  supplierId: number;
  mobileNumber: number;
  supplierName: string;
  supplierUserFullName: string;
  isActive: boolean;
  isSuperUser: boolean;
  canModifyUser: boolean;
  hasWalletAccess: boolean;
  canRegisterLoan: boolean;
  canRegisterProductOrder: boolean;
  exp: number;
  hasWhiteListAccess: boolean;
}
export interface RefreshToken {
  refreshToken: string;
}
